const styles = theme => ({
  root: {
    marginBottom: theme.spacing.unit * 3,
    '&:last-child': {
      marginBottom: 0
    }
  }
});

export default styles;
